import {CommandService} from '@core/services/command.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {take} from 'rxjs/operators';
import {Router} from '@angular/router';

export class ScenariosCommandHandlerBase {
  constructor(
    protected router: Router,
    protected commandService: CommandService,
    protected fuseSplashScreenService: FuseSplashScreenService,
    protected snackBarService: SnackBarService) {
  }

  protected onCommandExecuted(command: PlatformCommand, response: any): void {

  }

  protected executeCommandToApi(command: PlatformCommand, handler: IPlatformToolHandler) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      command.projectId = '[PROJECT_ID]';
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('[PlatformFilterHandler] Command Response', commandResponse);

          this.onCommandExecuted(command, commandResponse);

          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectCommand']) {
            handler.executeCommand(commandResponse.fieldValues['RedirectCommand']);
            return;
          }
          if (commandResponse.fieldValues['RedirectUrl']) {
            const url = commandResponse.fieldValues['RedirectUrl'];
            this.fuseSplashScreenService.hide();
            if (commandResponse.fieldValues['OpenWithNewTab']) {
              if (handler && handler.invalidateSubject) {
                handler.invalidateSubject.invalidate('Refresh');
              }
              this.openRouteInNewWindow(url);
            } else {
              this.router.navigateByUrl(url);
            }
            return;
          }
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (handler && handler.invalidateSubject) {
            handler.invalidateSubject.invalidate('Refresh');
          }
        },
        error => {
          this.fuseSplashScreenService.hide();
        });
    }
  }

  openRouteInNewWindow(routeUrl) {
    // Converts the route into a string that can be used
    // with the window.open() function
    const url = this.router.serializeUrl(
      this.router.createUrlTree([routeUrl])
    );
    window.open(url, '_blank', 'noreferrer').focus();
  }
}
